import React from 'react';

import Router from './components/navigation/Router';
import { AppStyle } from './styles';

function App() {
  return (
    <div className="App">
      <AppStyle />
      <Router />
    </div>
  );
}

export default App;
